import Swal from 'sweetalert2'
import { authHeader } from './authHeader';
import Loader from '../Components/Loader'
import { Fragment } from 'react'
import ReactDOM from 'react-dom'

var url_json = require('../location.json')

if (window.location.origin.includes('localhost')) {
  url_json = url_json.local
} else {
  url_json = url_json.production
}

const Titulacion = {
  obtenerTitulaciones: async () => {
    let url = url_json + '/titulacion'
    let request = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    }

    let response = await fetch(url, request)
    let json = await response.json()
    return { success: response.ok, data: json.data, code: json.message }
  },
  obtenerUnaTitulacion: async (id) => {
    let url = url_json + '/titulacion/' + id
    let request = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    }

    let response = await fetch(url, request)
    let json = await response.json()
    return { success: response.ok, data: json.data, code: json.message }
  },
  editarTitulacion: async (data, id) => {
    return Swal.fire({
      icon: 'question',
      title: '¿Esta seguro que desea modificar la titulacion?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Si',
      denyButtonText: `No`
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById('loader_padre')
        )

        let url = url_json + '/titulacion/' + id

        let body = {
          carpeta_investigacion: data.carpeta_investigacion,
          carpeta_produccion: data.carpeta_produccion,
          descripcion: data.descripcion,
          licenciatura: data.licenciatura,
          presentacion_final: data.presentacion_final,
          cuatrimestre7: data.cuatrimestre7,
          cuatrimestre8: data.cuatrimestre8,
          cuatrimestre9: data.cuatrimestre9
        }
        let request = {
          method: 'PATCH',
          body: JSON.stringify(body),
          headers: {
            'Content-type': 'application/json; charset=UTF-8'
          }
        }

        let response = await fetch(url, request)
        let res = await response.json()

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById('loader_padre')
        )

        if (response.ok) {
          Swal.fire(
            'Modificación exitosa!',
            'Titulacion modificada correctamente',
            'success'
          )
        } else {
          Swal.fire(
            'Error!',
            'No se pudo modificar la titulacion',
            'error'
          )
        }
        return { success: response.ok, data: res.data }
      } else if (result.isDenied) {
        Swal.fire('Modificación cancelada', 'El campo quedo intacto', 'succes')
      }
    })
  }
}

export default Titulacion
